<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1 pb-2">
            <div class="row">
              <div class="col-md-8">
                <label>Tipo de sistema</label>
                <input
                  v-model="project_type.title"
                  id="name"
                  class="form-control"
                  type="text"
                />
              </div>
              <div class="col-md-4">
                <label>Status</label>
                <select v-model="project_type.status" class="form-control">
                  <option :value="1">Ativo</option>
                  <option :value="0">Inativo</option>
                </select>
              </div>
              <div class="col-md-12 text-right">
                <hr />
                <router-link to="/project_types" class="btn btn-back mr-1">
                  <i class="fa fa-arrow-left" />
                  Voltar
                </router-link>
                <a class="btn btn-add" @click="save">
                  Salvar
                  <i class="fa fa-save" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      project_type: {
        status: "1",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "project_types";

      if (self.project_type.id) {
        api += "/" + self.project_type.id;
      }

      axios
        .post(api, self.project_type)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/project_types");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProjectType: function (id) {
      const self = this;
      const api = self.$store.state.api + "project_types/" + id;

      axios
        .get(api)
        .then((response) => {
          self.project_type = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },

  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      self.getProjectType(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>